import { fmtMoney, yearLabel } from '../lib/format';
import type { DerivedBudget } from '../lib/totals';

type Props = {
  derived: DerivedBudget;
  baseYear: number;
  cpiY1: number;
  cpiY2: number;
  cpiY3: number;
};

export function SummaryStrip({ derived, baseYear, cpiY1, cpiY2, cpiY3 }: Props) {
  const { grandNet } = derived;
  const cumulative3yr = grandNet.y1 + grandNet.y2 + grandNet.y3;

  const cards = [
    {
      label: `${yearLabel(baseYear, 0)} Net`,
      value: grandNet.current,
      sub: 'Current year, all activities',
    },
    { label: `${yearLabel(baseYear, 1)} Net`, value: grandNet.y1, sub: `at ${cpiY1}% CPI` },
    { label: `${yearLabel(baseYear, 2)} Net`, value: grandNet.y2, sub: `at ${cpiY2}% CPI` },
    { label: `${yearLabel(baseYear, 3)} Net`, value: grandNet.y3, sub: `at ${cpiY3}% CPI` },
    {
      label: '3-Year Cumulative',
      value: cumulative3yr,
      sub: `${yearLabel(baseYear, 1)} + ${yearLabel(baseYear, 2)} + ${yearLabel(baseYear, 3)}`,
    },
  ];

  return (
    <section className="panel mb-4 summary-strip">
      <div className="panel-section grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 summary-strip-grid">
        {cards.map((c) => (
          <div key={c.label} className="summary-strip-card">
            <div className="text-[11px] uppercase tracking-[0.08em] text-ccaanz-grey font-medium summary-strip-label">
              {c.label}
            </div>
            <div
              className={`text-[26px] font-semibold mt-1 num summary-strip-value ${
                c.value >= 0 ? 'text-ccaanz-blue' : 'text-ccaanz-black'
              }`}
            >
              {fmtMoney(c.value)}
            </div>
            <div className="text-[11px] text-ccaanz-grey mt-0.5 summary-strip-sub">{c.sub}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
